import { render, staticRenderFns } from "./PlayerOverview.vue?vue&type=template&id=5a361a12&"
import script from "./PlayerOverview.vue?vue&type=script&lang=js&"
export * from "./PlayerOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports